// extracted by mini-css-extract-plugin
export var circle = "_33-2";
export var icon = "_33-a";
export var iconHighlight = "_33-0";
export var lg = "_33-8";
export var md = "_33-7";
export var outline = "_33-4";
export var sm = "_33-6";
export var square = "_33-1";
export var xl = "_33-9";
export var xs = "_33-5";
export var xxs = "_33-3";